import { Box, Chip, Grid, IconButton, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import PropTypes from "prop-types";

import { BORDER_RADIUS } from "../../utils/constants";
import { NOT_READY, VALID } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import _ from "lodash";
import { BOX_SHADOW_THEME, INPUT_COLOR_BORDER } from "../../utils/colors";

/**
 * Componente reutilizable para mostrar una tarjeta de audiencia personalizada.
 *
 * @param {object} props
 * @param {string} props.title - El título principal de la tarjeta.
 * @param {Function} props.onDelete - La función a ejecutar cuando se hace clic en el botón de eliminar.
 * @param {boolean} [props.disabled=false] - Si es `true`, el botón de eliminar se oculta.
 * @param {React.ReactNode} [props.children] - Elementos hijos para mostrar como detalles adicionales debajo del título.
 * @param {object} [props.sx] - Estilos personalizados para el contenedor principal de la tarjeta.
 */
const AudienceCard = ({ title, isValid, onDelete, disabled, children, sx }) => {
  const { t } = useTranslationApp();

  const propIsValidPassed = _.isBoolean(isValid);

  return (
    <Grid item xs={12}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          border: `1px solid ${INPUT_COLOR_BORDER}`,
          boxShadow: BOX_SHADOW_THEME,
          p: 2,
          borderRadius: BORDER_RADIUS,
          height: "100%",
          ...sx,
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Typography
              variant="body1"
              sx={{ fontWeight: 600 }}
              title={title}
              noWrap
            >
              {title}
            </Typography>
            {propIsValidPassed && (
              <Chip size="small" label={t(isValid ? VALID : NOT_READY)} />
            )}
          </Box>
          {children}
        </Box>
        {!disabled && (
          <IconButton
            edge="end"
            sx={{
              p: 0,
              mr: 0.2,
              flexShrink: 0,
            }}
            onClick={onDelete}
            aria-label="delete audience"
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Box>
    </Grid>
  );
};

AudienceCard.propTypes = {
  title: PropTypes.string.isRequired,
  onDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
  sx: PropTypes.object,
};

export default AudienceCard;
